import React from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 
import Unauthorized from "./components/Unauthorized";
import { AppSettingsProvider } from "./context/AppSettingsContext";
import ChatPage from "./components/ChatPage";
import AuthGuard from "./guard/AuthGuard";
import { AuthProvider } from "./context/AuthContext";
import { AppEnvProvider } from './context/AppEnvContext';

const ChatWrapper = () => {
  const { token } = useParams();
  
  // If token is not present, show Unauthorized page
  if (!token) {
    return <Unauthorized />;
  }

  // You can decode the token to extract clientId, eventId, accountId1, etc., if necessary.
  // For now, we are passing the token directly.
  return (
    <AppSettingsProvider token={token}>
      <ChatPage token={token} />
    </AppSettingsProvider>
  );
};

function App() {
  return (
    <AppEnvProvider>
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        
        {/* Chat Route with token as parameter */}
        <Route
          path="/chat/:token"
          element={
            <AuthProvider>
              <AuthGuard>
              <ChatWrapper />
            </AuthGuard>
            </AuthProvider>
          }
        />
        {/* Fallback Route */}
        <Route path="*" element={<Unauthorized />} />
      </Routes>
    </Router>
    </AppEnvProvider>
  );
}

export default App;
